

export const Subrogation = () => {
    return (
        <>
         <div className="container-fluid">
            <div className="row pb-5">

                <div className="col-lg-12 text-center pb-5">
                    <h2 className=" mt-4 fw-bold">Subrogation  </h2>
                    <div className="col-8 col-lg-3 mx-auto zoom-in-out-box2 ">
                        <hr />
                    </div>
                </div>


                <div className="col-12 col-lg-12 mx-auto px-lg-5 pb-3">
                    <div className="p-lg-2 p-4 " style={{ textAlign: 'justify', }}>
                        <p>Fundamental Principle of Indemnity do not allow the assured to recover his loss under the policy and also from the person liable for such loss and thus gain out of his loss.</p>

                        <p> We take an example of the assured who has arrange the transit insurance for his cargo. The carrying vehicle met with an accident and the said claim for damage to cargo was settled by the Insurance Company. The assured also proceed the claim with the carrier and claim for the cargo damage during transit as per the terms of his contract of carriage. In case he succeeded to get a claim from the carrier, he (assured) can make a benefit out of his loss. </p>

                        <p>The principle of subrogation avoids such benefits to the assured by transferring the rights of recovery to the insurance company who has already settled the loss under the transit insurance policy and implement the fundamental principle of Indemnity. </p>

                        <p>Rights of the insurer on payment of a loss to stand in the shoes of the assured and to avail himself of his rights and remedies is protected by the principle of subrogation. </p>

                        <p>Section 79 of the Marine Insurance Act 1906 defines the Right of Subrogation as rights of insurer on payment.  </p>
                    </div>
                </div>

                <div className="col-12 px-lg-5">
                    <div className="p-lg-5 p-4 bgservices " style={{ textAlign: 'justify', }}>
                        <h5 className="fw-bold pb-3">Case Law: </h5>

                        <p><b>Yorkshire Insurance v Nisbet [1961] </b> </p>
                        <p>Subrogation limited to amount paid by underwriter plus interest.</p>

                        <p>
                            The insured vessel was in collision in 1945 with a Canadian naval vessel as a result of which her Underwriters paid a total loss of £72,000 on a valued policy. Her actual value at the time of loss was £75,514 (or $336,059 at the rate of exchange operating then). The shipowners recovered $336,059 from the Canadian Government in 1959 but by "selling" these they obtained nearly £127,000, the pound having been devalued in September, 1949. The difference between the insured value and the recovery being in the region of £55,000. It was held that the assured is entitled to the benefit of the excess recovery.
                        </p>

                    </div>
                </div>

                <div className="col-12 px-lg-5 mt-5 ">
                    <div className=" food_for_health" >

                        <div className="row p-lg-5 p-4">
                            <div className="col-12 col-lg-8">
                                <p><b> Food for Thought:  </b></p>

                                <p><i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    How the recoveries under subrogation are apportioned between the underwriter and the assured?
                                </p>

                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>	Does underinsurance play any role in the recoveries?</p>

                                <p><i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    Does the non-protection of the recovery rights of the underwriter has any effect on the claim?
                                </p>

                                <p><i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    Does the underwriter have the better rights than the assured?
                                </p>

                                <p><i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    What is the “Top-Down” approach for the apportionment of the recoveries?
                                </p>

                            </div>
                            <div className="col-12 col-lg-4 d-flex align-items-center justify-content-center">
                                <img src="Static/Assets/Img/questionary.png" className="questionery_img mx-auto" alt="" srcset="" />

                            </div>

                        </div>


                    </div>
                </div>
            </div>
            </div>
            {/* <Footer />
                </div>
            </div> */}
        </>
    )
}
